// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"254":"7988d23c","483":"ce8154a1"}[chunkId] + ".chunk.js");